import { config_settings } from '@/config.js';
import Vue from 'vue';

export const getDepartaments = () => {
  return Vue.$http.get(config_settings.RESOURCE_SERVER_URL + '/GET/locations/departments');
};

export const getProvinces = (idDepartament) => {
  return Vue.$http.get(
    config_settings.RESOURCE_SERVER_URL +
      '/GET/locations/departaments/' +
      idDepartament +
      '/provinces',
  );
};

export const getDistricts = (idProvince) => {
  return Vue.$http.get(
    config_settings.RESOURCE_SERVER_URL +
      '/GET/locations/departments/provinces/' +
      idProvince +
      '/districts',
  );
};

export const getCompleteLocation = (idDistrict) => {
  return Vue.$http.get(config_settings.RESOURCE_SERVER_URL + '/GET/locations/' + idDistrict);
};
